// extracted by mini-css-extract-plugin
export default {"wrapper":"fn-z","viewport":"gn-z","container":"hn-z","slide":"in-z"};